import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import {
  Alert,
  Backdrop,
  Box,
  Button,
  Dialog,
  Fade,
  Stack,
  Typography,
} from "@mui/material";

export default function PurchaseActionDialog({
  open,
  action,
  purchase,
  loading,
  error,
  approvalRequiresReview = false,
  approvalActionLabel = "Aprobar",
  approvalLoadingLabel = "Aprobando...",
  onClose,
  onConfirm,
  onViewPurchase,
}) {
  const isApproval = action === "approve";
  const showViewPurchaseAction = isApproval && approvalRequiresReview;
  const actionLabel = isApproval ? approvalActionLabel : "Eliminar";
  const loadingLabel = isApproval ? approvalLoadingLabel : "Eliminando...";

  return (
    <Dialog
      open={Boolean(open)}
      onClose={loading ? undefined : onClose}
      closeAfterTransition
      slots={{ backdrop: Backdrop }}
      PaperProps={{
        sx: {
          bgcolor: "transparent",
          boxShadow: "none",
          borderRadius: "30px",
          overflow: "visible",
        },
      }}
      slotProps={{
        backdrop: {
          timeout: 180,
          sx: {
            bgcolor: "rgba(2, 8, 23, 0.45)",
            backdropFilter: "blur(3px)",
          },
        },
      }}
    >
      <Fade in={Boolean(open)} timeout={180}>
        <Box
          sx={{
            bgcolor: "neutral.500",
            borderRadius: "32px",
            p: { xs: 2.5, sm: 3.5 },
            boxShadow: "0px 20px 60px rgba(0,0,0,.28)",
            width: "min(92vw, 560px)",
          }}
        >
          <Stack spacing={2.5} sx={{ alignItems: "center" }}>
            <Box
              sx={{
                px: 3,
                py: 1.2,
                bgcolor: "secondary.50",
                borderRadius: "33px",
                boxShadow: "inset 0px 0px 3px rgba(142, 142, 159, 0.5)",
              }}
            >
              <Typography
                sx={{ color: "primary.900", fontSize: 19, fontWeight: 800 }}
              >
                {actionLabel} compra
              </Typography>
            </Box>

            <Box
              sx={{
                width: "100%",
                bgcolor: "neutral.50",
                borderRadius: "22px",
                p: { xs: 2.25, sm: 2.75 },
                boxShadow: "inset 0px 0px 2px rgba(96, 96, 113, 0.5)",
              }}
            >
              <Typography
                sx={{ color: "primary.900", fontSize: 17, fontWeight: 700 }}
              >
                {isApproval
                  ? `¿Querés aprobar la compra de ${purchase?.supplier?.name || "este proveedor"}?`
                  : `¿Querés eliminar la compra pendiente de ${purchase?.supplier?.name || "este proveedor"}?`}
              </Typography>
              {isApproval ? (
                <Typography
                  sx={{ mt: 1, color: "neutral.700", fontSize: 13, fontWeight: 600 }}
                >
                  Una vez aprobada, la compra quedará bloqueada y actualizará los
                  precios correspondientes.
                </Typography>
              ) : null}
              {error ? (
                <Alert severity="error" sx={{ mt: 2 }}>
                  {error}
                </Alert>
              ) : null}
            </Box>

            <Stack
              direction="row"
              spacing={1.5}
              sx={{ width: "100%", justifyContent: "flex-end" }}
            >
              <Button
                variant="contained"
                onClick={onClose}
                disabled={loading}
                sx={{
                  px: 3,
                  minHeight: 44,
                  borderRadius: "33px",
                  bgcolor: "secondary.50",
                  color: "primary.900",
                  textTransform: "none",
                  fontSize: 15,
                  fontWeight: 800,
                  "&:hover": { bgcolor: "secondary.100" },
                }}
              >
                Cancelar
              </Button>
              <Button
                variant="contained"
                startIcon={
                  showViewPurchaseAction ? (
                    <VisibilityOutlinedIcon />
                  ) : isApproval ? (
                    <CheckCircleOutlineIcon />
                  ) : (
                    <DeleteOutlineIcon />
                  )
                }
                onClick={showViewPurchaseAction ? onViewPurchase : onConfirm}
                disabled={loading}
                sx={{
                  px: 3,
                  minHeight: 44,
                  borderRadius: "33px",
                  bgcolor: isApproval ? "primary.500" : "secondary.500",
                  color: "logoblanco",
                  textTransform: "none",
                  fontSize: 15,
                  fontWeight: 800,
                  "&:hover": {
                    bgcolor: isApproval ? "primary.600" : "secondary.600",
                  },
                }}
              >
                {showViewPurchaseAction
                  ? "Ver Lista de compra"
                  : loading
                  ? loadingLabel
                  : actionLabel}
              </Button>
            </Stack>
          </Stack>
        </Box>
      </Fade>
    </Dialog>
  );
}
